/* eslint-disable react/jsx-no-undef */
import { Field as FinalFormField } from 'react-final-form';
import { isDefined } from '@rainbow-modules/validation';
import { validateNotEmpty } from 'data/validators';
import {
    StyledInput, StyledTextarea,
} from './styled';
import PlatformPicker from './platformPicker';

const validateCustomPickValue = (
    value?: { name: string, label: string, value: string } | string,
) => {
    if (!value) {
        return 'This field is required';
    }
    if (typeof value !== 'string' && isDefined(value) && value?.name === 'custom' && !value.value) {
        return 'You must pick a value';
    }
    return undefined;
};

const Field = (props: any) => <FinalFormField parse={(value) => value} {...props} />;

const Fields = ({
    disabledFields = [],
}: {
    disabledFields?: string[];
}) => (
    <>
        <Field
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            component={StyledInput}
            name="name"
            label="Name"
            labelAlignment="left"
            placeholder="Your external automation name"
            borderRadius="semi-rounded"
            autoComplete="off"
            required
            validate={validateNotEmpty('This field is required')}
            disabled={disabledFields.includes('name')}
        />
        <Field
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            component={StyledTextarea}
            name="description"
            label="Description"
            labelAlignment="left"
            placeholder="Your external automation description"
            borderRadius="semi-rounded"
            autoComplete="off"
            disabled={disabledFields.includes('description')}
        />
        <Field
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            component={PlatformPicker}
            name="platform"
            label="Platform"
            labelAlignment="left"
            placeholder="Select platform"
            borderRadius="semi-rounded"
            disabled={disabledFields.includes('platform')}
            validate={validateCustomPickValue}
            required
        />
    </>
);

export default Fields;
